import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";

import { hqEnvironment } from "@intocare/environments";

import { AppModule } from "./app/app.module";

if (hqEnvironment.SENTRY) {
	Sentry.init({
		dsn: hqEnvironment.SENTRY?.URL,
		environment: hqEnvironment.environment,
		release: hqEnvironment.VERSION,
		denyUrls: ["localhost"],
		/**
		 * Workaround to solve https://github.com/getsentry/sentry-javascript/issues/2744 Errors are reported multiple
		 * times: one error is correctly catched via angular ErrorHandler, second one is catched by captureException
		 * executed inside sentryWrapped function. The TryCatch integration seems to step in to catch errors in timer
		 * functions before our Angular-specific ErrorHandler catches the error again. This is solved by disabeling the
		 * TryCatch integration.
		 */
		integrations: (defaultIntegrations) => {
			return [...defaultIntegrations.filter((i) => i.name !== "TryCatch")];
		},
		beforeSend(event) {
			const organisation = window.localStorage.getItem("currentOrganisation");
			event.tags = event.tags || {};
			event.tags["organisation"] = organisation;

			return event;
		},
	});
}

if (hqEnvironment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
